module.exports = __webpack_public_path__ + "static/media/avi.9adf8004.svg";